export default {
  application_setting: '应用设置',
  application_information: '应用信息',
  public_key: '公钥',
  shared_application_setting : '统一应用设置',
  secret_key: '秘钥',
  ip_white_list: 'IP白名单',
  ip_address: 'IP地址',
  user_authentication: '用户认证'
}
